<template>
  <main>
    <MobileHeader />
    <slot />
    <MobileFooter />
  </main>
</template>

<script>
import MobileHeader from '~/components/header/MobileHeader.vue'
import MobileFooter from '~/components/footer/MobileFooter.vue'

export default {
  name: 'SignLoginLayout',
  components: {
    MobileHeader,
    MobileFooter
  }
}
</script>

<style scoped></style>
